export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/237681172545"
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors hover:scale-105 animate-scale-in"
      aria-label="Contact us on WhatsApp"
    >
      <div className="w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </div>
    </a>
  );
}